/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Location_PlaceInputs */

const vi_camera_location_place = /** @type {(inputs: Camera_Location_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gắn vùng`)
};

/**

* @param {Camera_Location_PlaceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_location_place = /** @type {((inputs?: Camera_Location_PlaceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Location_PlaceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_location_place(inputs)
});